import { api } from "@/APIRequests";
import type { GoalsAndObjectivesResponse } from "@/core/types";

export async function getGoalsAndObjectives(
  patientId: string,
): Promise<GoalsAndObjectivesResponse> {
  return api.carePlanTyped.get_goals_and_objectives({
    params: { showLoader: false },
    patientId,
  });
}
